import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

// Réplica de ActionsCell (hrbf_freezer/src/ui/components/Table/ActionsCell.jsx): un icono de
// lucide dentro de un IconButton pequeño, con tooltip. Corta el clic para no abrir la fila.
const ActionsCell = ({ icon, onClick, tooltip, disabled, ...rest }) => {
  const handleClick = event => {
    event.stopPropagation()
    if (!disabled && onClick) onClick(event)
  }

  return (
    <Tooltip title={tooltip || ''}>
      <span>
        <IconButton size="small" onClick={handleClick} disabled={disabled} aria-label={typeof tooltip === 'string' ? tooltip : undefined} {...rest}>
          {icon}
        </IconButton>
      </span>
    </Tooltip>
  )
}

ActionsCell.propTypes = {
  icon: PropTypes.node,
  onClick: PropTypes.func,
  tooltip: PropTypes.node,
  disabled: PropTypes.bool
}

// Contenedor de la columna «Acciones»: los iconos juntos, alineados a la izquierda
export const ActionsGroup = ({ children }) => <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>{children}</div>

ActionsGroup.propTypes = {
  children: PropTypes.node
}

export default ActionsCell
